/* eslint-disable */
import { createTheme } from '@mui/material/styles';

/**
 * Urban Dashboard custom MUI theme
 * Applies premium visual overrides for palette, typography, shape, and card components.
 *
 * Requirements: 7.1, 7.4, 7.5, 7.6
 */
const urbanTheme = createTheme({
    palette: {
        primary: {
            main: '#4F46E5', // Premium Indigo
            light: '#EEF2F6',
            dark: '#3730A3',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#0D9488', // Premium Teal
            light: '#F0FDFA',
            dark: '#115E59'
        },
        success: {
            main: '#10B981', // Emerald
            light: '#ECFDF5',
            dark: '#065F46'
        },
        warning: {
            main: '#F59E0B', // Amber
            light: '#FEF3C7',
            dark: '#92400E'
        },
        error: {
            main: '#F43F5E', // Rose
            light: '#FFF1F2',
            dark: '#9F1239'
        },
        background: {
            default: '#F8FAFC', // Slate 50
            paper: '#FFFFFF'
        },
        text: {
            primary: '#0F172A', // Slate 900
            secondary: '#475569', // Slate 600
            disabled: '#94A3B8'
        },
        divider: '#E2E8F0' // Slate 200
    },
    shape: {
        borderRadius: 12 // Precision geometric border-radius
    },
    typography: {
        fontFamily: ['Inter', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
        h4: {
            fontSize: '24px',
            fontWeight: 600,
            letterSpacing: '-0.02em',
            color: '#0F172A'
        },
        h5: {
            fontSize: '20px',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            color: '#0F172A'
        },
        subtitle1: {
            fontSize: '15px',
            fontWeight: 500,
            letterSpacing: '-0.005em',
            color: '#475569'
        },
        body2: {
            fontSize: '13.5px',
            fontWeight: 400,
            lineHeight: 1.5,
            color: '#475569'
        },
        caption: {
            fontSize: '11px',
            fontWeight: 500,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            color: '#94A3B8'
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    border: '1px solid rgba(15, 23, 42, 0.08)',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.02), 0 1px 2px -1px rgba(0, 0, 0, 0.02)',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 500,
                    textTransform: 'none',
                    letterSpacing: '-0.01em',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    }
                }
            }
        }
    }
});

export default urbanTheme;
